interface Routes {
  index: string;
  registration: string;
  registrationWelcomePage: string;
  registrationUserData: string;
  registrationUserPhotos: string;
  registrationUserSelfie: string;
  login: string;
  search: string;
  messenger: string;
  likes: string;
  chat: string;
  profile: string;
  profileSettings: string;
  selectLocale: string;
  profileNotifications: string;
  profilePrivacy: string;
  profileAccount: string;
  profileHideAccount: string;
  profileEdit: string;
  support: string;
  earnTon: string;
  withdrawTon: string;
  withdrawTonDetails: string;
  withdrawTonSuccess: string;
  accessDenied: string;
  deletedProfile: string;
  verificationFailed: string;
  banned: string;
}

export const routes: Routes = {
  index: '/',
  registration: '/registration',
  registrationWelcomePage: '/registration/welcome',
  registrationUserData: '/registration/userData',
  registrationUserPhotos: '/registration/userPhotos',
  registrationUserSelfie: '/registration/userSelfie',
  login: '/login',
  search: '/search',
  messenger: '/messenger',
  likes: '/messenger/likes',
  chat: '/messenger/chat/:id',
  profile: '/profile',
  profileSettings: '/profile/settings',
  selectLocale: '/profile/settings/locale',
  profileNotifications: '/profile/settings/notifications',
  profilePrivacy: '/profile/settings/privacy',
  profileAccount: '/profile/settings/account',
  profileHideAccount: '/profile/settings/hideAccount',
  profileEdit: '/profile/edit',
  support: '/support',
  earnTon: '/ton/earn',
  withdrawTon: '/ton/withdraw',
  withdrawTonDetails: '/ton/withdraw/details',
  withdrawTonSuccess: '/ton/withdraw/success',
  accessDenied: '/accessDenied',
  deletedProfile: '/deletedProfile',
  verificationFailed: '/verificationFailed',
  banned: '/banned'
};
